import React, { useState } from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import YoutubeModal from "../youtube-player-modal"

const CardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background-color: #1c1c1c;
  color: white;
  padding: 26px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 234px;
  border-radius: 16px;
  border: 1px solid #fff;

  @media (max-width: 550px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 16px;
    height: 392px;
  }
`

const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 550px) {
    order: 2;
  }
  @media (min-width: 550px) {
    margin-right: 26px;
  }
`

const Name = styled.h4`
  margin: 0;
  font-size: 1.1rem;
  font-weight: bold;
`

const Subtitle = styled.p`
  margin: 4px 0;
  font-size: 0.9rem;
  color: #aaaaaa;
`

const ReviewText = styled.p`
  font-size: 0.9rem;
  margin: 8px 0 0;
  line-height: 1.4;
`

const Stars = styled.div`
  display: flex;
  align-items: center;
  color: #ffc107;
  margin: 4px 0;
`

const Star = styled.span`
  font-size: 24px;
`

const ImageSection = styled.div`
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  width: 158px;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  background:
    linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%),
    url(${props => props.$url}) lightgray 50% / cover no-repeat;

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 550px) {
    width: 100%;
    height: 138px;
    order: 1;
  }
`

const TestimonialCard = ({ name, subtitle, review, stars = 5, image, url }) => {
  const [showModal, setShowModal] = useState(false)
  const handleModalClose = () => setShowModal(false)

  return (
    <CardContainer>
      <TextSection>
        <Name>{name}</Name>
        <Subtitle>{subtitle}</Subtitle>
        <Stars>
          {[...Array(stars)].map((_, index) => (
            <Star key={index}>&#9733;</Star>
          ))}
        </Stars>
        <ReviewText>{review}</ReviewText>
      </TextSection>
      <ImageSection
        $url={image}
        onClick={() => {
          setShowModal(true)
        }}
      >
        <PlayButton />
      </ImageSection>
      {showModal ? (
        <YoutubeModal
          id={`${name}-video`}
          isOpen={showModal}
          onClose={handleModalClose}
          videoId={url.slice(-11)}
        />
      ) : null}
    </CardContainer>
  )
}

TestimonialCard.propTypes = {
  name: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  review: PropTypes.string.isRequired,
  stars: PropTypes.number,
  image: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}

export default TestimonialCard

const PlayButton = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="32"
      viewBox="0 0 26 32"
      fill="none"
    >
      <path
        d="M1.99655 25.2805V25.2774V6.65066C1.99738 5.79059 2.23628 4.94753 2.6868 4.21489C3.13744 3.48206 3.78221 2.88832 4.54963 2.4995C5.31705 2.11067 6.17715 1.94195 7.0346 2.01202C7.89201 2.08209 8.71328 2.38821 9.40737 2.89645C9.4074 2.89647 9.40742 2.89648 9.40744 2.8965L21.9893 12.1225C22.0258 12.1536 22.0636 12.1836 22.1026 12.2122L22.103 12.2125C22.6918 12.6451 23.1706 13.2101 23.5007 13.8618C23.8312 14.5143 24.0035 15.2355 24.0035 15.9669C24.0035 16.6983 23.8312 17.4194 23.5007 18.0719C23.1704 18.7242 22.6911 19.2895 22.1017 19.7222C22.1016 19.7222 22.1016 19.7223 22.1015 19.7223C22.1014 19.7224 22.1012 19.7225 22.1011 19.7226L9.40637 29.0314L9.40362 29.0334C8.7104 29.5436 7.88921 29.8513 7.03145 29.9224C6.17369 29.9936 5.31302 29.8253 4.54525 29.4363C3.77747 29.0473 3.13271 28.4528 2.68273 27.7191C2.23275 26.9854 1.99521 26.1412 1.99655 25.2805Z"
        stroke="white"
        strokeWidth="3.99308"
      />
    </svg>
  )
}
